import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByRoles(options = {}) {
  return _apiRequestWrap(
    ModulesMap.REPORTS_FINANCE_BY_ROLES,
    ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_ROLES].GET_REPORTS_FINANCE_BY_ROLES,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_ROLES].GET_REPORTS_FINANCE_BY_ROLES]: _getReportsFinanceByRoles,
}